// Demo admin repair was a Firestore self-heal for `tenants/etqan-madrasa`
// + `users/{uid}`. Post-cutover the demo tenant is seeded server-side and
// the admin's Postgres row is created during normal signup. Keeping the
// constants exported so the Login demo tile still works; the repair fn
// itself is a no-op and never throws.

export const DEMO_ADMIN_EMAIL = 'admin@etqan.demo';
export const DEMO_TENANT_ID = 'etqan-madrasa';

export const repairDemoAdminProfile = async () => {
  // No-op post Phase 8.3. The api backend's seed scripts own the demo
  // admin / tenant docs; there is no longer a self-heal path on the
  // client.
};

export default repairDemoAdminProfile;
